module.exports = {"paymentMethod":{"credit":"Cartão de crédito","money":"Dinheiro","bankSlip":"Boleto","partners":"Parceiros","debit":"Cartão de débito"},"type":{"manual":"Recarga Manual","auto":"Recarga Automática"},"title":{"date":"Data","hour":"Hora","payment":"Pagamento","type":"Tipo","value":"Valor total (R$)"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/RechargeListItem/data.json
// module id = 2038
// module chunks = 0